module.exports = __webpack_public_path__ + "img/wild_comming.bef89783.png";